/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PublicProductSku } from './PublicProductSku';
import {
    PublicProductSkuFromJSON,
    PublicProductSkuFromJSONTyped,
    PublicProductSkuToJSON,
} from './PublicProductSku';

/**
 * Note: used by a view which *any* authenticated user can call without needing further permissions.
 * This is essentially 'public' because anyone can sign up for HPID, so care should be taken
 * to not return more data than is absolutely necessary for the WPSE device affiliation flow.
 * @export
 * @interface PublicDeviceLookup
 */
export interface PublicDeviceLookup {
    /**
     * 
     * @type {string}
     * @memberof PublicDeviceLookup
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicDeviceLookup
     */
    readonly userFacingId: string;
    /**
     * 
     * @type {Date}
     * @memberof PublicDeviceLookup
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {PublicProductSku}
     * @memberof PublicDeviceLookup
     */
    readonly product: PublicProductSku;
    /**
     * 
     * @type {string}
     * @memberof PublicDeviceLookup
     */
    readonly tenantId: string | null;
}

/**
 * Check if a given object implements the PublicDeviceLookup interface.
 */
export function instanceOfPublicDeviceLookup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "userFacingId" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "product" in value;
    isInstance = isInstance && "tenantId" in value;

    return isInstance;
}

export function PublicDeviceLookupFromJSON(json: any): PublicDeviceLookup {
    return PublicDeviceLookupFromJSONTyped(json, false);
}

export function PublicDeviceLookupFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicDeviceLookup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userFacingId': json['user_facing_id'],
        'createdAt': (new Date(json['created_at'])),
        'product': PublicProductSkuFromJSON(json['product']),
        'tenantId': json['tenant_id'],
    };
}

export function PublicDeviceLookupToJSON(value?: PublicDeviceLookup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

